"use client";

import { DropdownMenuItem } from "@/components/ui/dropdown-menu";
import { removeFromS3, deleteFolder } from "@/lib/documenti/actions";
import { Button } from "@/components/ui/button";
import { ActionTrigger } from "@/lib/action";
import { Download, MoreHorizontal, Trash, FolderOpen } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
  DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";
import { S3Document } from "@/types/types";
import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";

export function DocumentoMoreButton({ documento }: { documento: S3Document }) {
  const [confirmDelete, setConfirmDelete] = useState(false);
  const isFolder = documento.isFolder;

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" size="icon">
            <MoreHorizontal className="h-4 w-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="min-w-48 p-2">
          {!isFolder && (
            <DropdownMenuItem asChild className="mb-2">
              <a
                href={documento.dlLink || ""}
                className="justify-start"
                download
              >
                <Download className="h-4 w-4" />
                <span className="ml-4">
                  Scarica {isFolder ? "cartella" : "documento"}
                </span>
              </a>
            </DropdownMenuItem>
          )}

          {isFolder && (
            <DropdownMenuItem asChild className="mb-2">
              <a
                href="#"
                className="justify-start"
                onClick={(e) => {
                  e.preventDefault();
                  // Open folder code goes here
                  console.log("Open folder:", documento.posizione);
                }}
              >
                <FolderOpen className="h-4 w-4" />
                <span className="ml-4">Apri cartella</span>
              </a>
            </DropdownMenuItem>
          )}

          {/* Riga sottile tra le sezioni */}
          <DropdownMenuSeparator />

          <DropdownMenuItem
            className="text-destructive"
            onClick={() => setConfirmDelete(true)}
          >
            <Trash className="h-4 w-4 text-destructive" />
            <span className="ml-4">
              Elimina {isFolder ? "cartella" : "file"}
            </span>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      {/* Confirmation Dialog */}
      <Dialog open={confirmDelete} onOpenChange={setConfirmDelete}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle className="text-destructive">
              Conferma eliminazione
            </DialogTitle>
          </DialogHeader>
          <div className="py-4">
            <p className="mb-4">
              Sei sicuro di voler eliminare{" "}
              {isFolder ? "la cartella" : "il file"}:
              <span className="font-medium"> {documento.nome}</span>?
            </p>
            {isFolder && (
              <p className="text-sm text-amber-600 bg-amber-50 p-3 rounded border border-amber-200 mb-3">
                Attenzione: eliminando questa cartella eliminerai anche tutti i
                file contenuti in essa.
              </p>
            )}
            <p className="text-sm text-muted-foreground bg-destructive/10 p-3 rounded border border-destructive/20">
              Questa azione non può essere annullata.
            </p>
          </div>
          <DialogFooter className="gap-2">
            <Button variant="outline" onClick={() => setConfirmDelete(false)}>
              Annulla
            </Button>
            <ActionTrigger
              variant="destructive"
              action={isFolder ? deleteFolder : removeFromS3}
              input={documento.posizione || ""}
              onComplete={() => {
                setConfirmDelete(false);
                // Force refresh to update UI
                setTimeout(() => window.location.reload(), 500);
              }}
            >
              Elimina
            </ActionTrigger>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
